import { AxiosResponse } from 'axios';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteRule } from 'Services';
import {
    RQ_ALL_LIST,
    RQ_GLOBAL_RULES,
    RQ_HISTORY,
    RQ_PARAMETERS,
    RQ_LIST_BY_ID,
    RQ_RULE_GROUPS,
    RQ_MERCHANT_RULES,
    RQ_MERCHANT_OVERRIDES,
    RQ_TENANT_GROUP_OVERRIDES_INHERITED,
    RQ_TENANT_GROUP_OVERRIDES
} from 'Utils';

type Options = {
    mutationOptions: UseMutationOptions<AxiosResponse<any>, unknown, any, unknown>;
    templateRepositoryId: number;
};

function useDeleteRule({ mutationOptions, templateRepositoryId }: Options) {
    const queryClient = useQueryClient();
    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_GLOBAL_RULES, templateRepositoryId]);
        queryClient.invalidateQueries([RQ_RULE_GROUPS]);
        queryClient.invalidateQueries([RQ_HISTORY]);
        queryClient.invalidateQueries([RQ_ALL_LIST]);
        queryClient.invalidateQueries([RQ_LIST_BY_ID]);
        queryClient.invalidateQueries([RQ_PARAMETERS]);
        queryClient.invalidateQueries([RQ_MERCHANT_RULES]);
        queryClient.invalidateQueries([RQ_MERCHANT_OVERRIDES]);
        queryClient.invalidateQueries([RQ_TENANT_GROUP_OVERRIDES]);
        queryClient.invalidateQueries([RQ_TENANT_GROUP_OVERRIDES_INHERITED]);
    };

    return useMutation(deleteRule, {
        onSuccess: (data, variables, context) => {
            defaultSuccessHandler();
            mutationOptions.onSuccess?.(data, variables, context);
        },
        onError: async (error, variables, context) => {
            mutationOptions.onError?.(error, variables, context);
        }
    });
}

export default useDeleteRule;
